import React, { useEffect, useState } from "react";

import api from "../../../api";
import { Pagination, Stack } from "@mui/material";
import { Loader } from "../loader";
import moment from "moment";
import { useNavigate, useParams } from "react-router-dom";
import { Modal } from "react-bootstrap";
import { useSelector } from "react-redux";
import numeral from "numeral";

function ChallengesAdminByUserId({ adminType }) {
  const navigate = useNavigate();
  const params = useParams();
  const [page, setPage] = useState(1);
  const [limit, setLimit] = useState(50);
  const [data, setData] = useState([]);
  const [noOfChallengs, setNoOfChallengs] = useState(0);
  const [loader, setLoader] = useState(true);
  const [inputData, setInputData] = useState({});
  const [resetPage, setResetPage] = useState(false);
  const [firstRender, setfirstRender] = useState(false);
  const [selectedData, setSelectedData] = useState({});

  const getChallenges = async () => {
    try {
      setLoader(true);
      const userData = await api.AdminChallengesByUser(params?.userId);
      console.log(userData);
      if (userData?.success) {
        setData(userData.data);
        setNoOfChallengs(userData.totalItems);
      }
      setLoader(false);
    } catch (error) {
      console.log(error?.message);
      setLoader(false);
    }
  };

  useEffect(() => {
    if (params?.userId) {
      getChallenges();
    }
  }, []);

  return (
    <>
      <div className="container-fluid payHistoryPage">
        <div className="row">
          <div className="col">
            <div className="row mx-0 drivers-row">
              <div className="col-12   d-flex justify-content-between pr-0 flex-wrap">
                <h4 className="color-dark fs-17 dib font-weight-bold mr-5">
                  User Challenges
                </h4>
              </div>
            </div>

            {/* table */}
            <Table
              data={data}
              setPage={setPage}
              page={page}
              noOfChallengs={noOfChallengs}
              limit={limit}
            />
          </div>
        </div>
      </div>
      {/* /.container-fluid */}
      {loader && <Loader />}
    </>
  );
}
const Table = ({ data, page, setPage, noOfChallengs, limit }) => {
  // const authedUser = useSelector(s => s.authedUser.authedUser);

  const navigate = useNavigate();
  const handleChange = (event, value) => {
    setPage(value);
  };

  const formatDate = (date) => {
    let dateTemp = moment(date).format("MMMM Do YYYY, h:mm:ss a");
    return dateTemp;
  };

  return (
    <>
      <div className="card sortby-box br-10 border-transparent mt-3">
        <div className="card-header br-10  bg-white border-transparent py-3 ">
          <div className="table-responsive">
            <table className="table table-hover drivers-table">
              <thead>
                <tr>
                  <th scope="col" className="">
                    Challenge Id
                  </th>
                  <th scope="col" className="">
                    User Id
                  </th>
                  <th scope="col" className="">
                    Initial Balance
                  </th>
                  <th scope="col" className="">
                    Challenge Balance
                  </th>
                  <th scope="col" className="">
                    Target Balance
                  </th>
                  <th scope="col" className="">
                    Total Trades
                  </th>
                  <th scope="col" className="">
                    Progress Percentage
                  </th>
                  <th scope="col" className="">
                    Reward
                  </th>
                  <th scope="col" className="">
                    Profit Made
                  </th>
                  <th scope="col" className="">
                    Loss Made
                  </th>
                  <th scope="col" className="">
                    Plan Type
                  </th>
                  <th scope="col" className="">
                    Exit Time
                  </th>
                  <th scope="col" className="">
                    Start Date
                  </th>
                  <th scope="col" className="">
                    End Date
                  </th>
                </tr>
              </thead>
              <tbody>
                {data.map((item, key) => (
                  <tr key={key}>
                    <td>
                      <div className="table-text-dark w-max-c db">
                        <div className="shortId">
                          {item?._id ? item?._id?.slice(0, 4) + "..." : "-"}
                        </div>
                      </div>
                    </td>
                    <td>
                      <div className="table-text-dark w-max-c db">
                        {item?.userId ? item?.userId?.slice(0, 4) + "..." : "-"}
                      </div>
                    </td>
                    <td>
                      <div className="table-text-dark w-max-c db">
                        {numeral(item?.initialBalance).format("$0,0")} USD
                      </div>
                    </td>

                    <td>
                      <div className="table-text-dark w-max-c db">
                        {numeral(item?.challengeBalance).format("$0,0")} USD
                      </div>
                    </td>
                    <td>
                      <div className="table-text-dark w-max-c db">
                        {numeral(item?.targetBalance).format("$0,0")} USD
                      </div>
                    </td>
                    <td>
                      <div className="table-text-dark w-max-c db">
                        {item?.totalTrades}
                      </div>
                    </td>
                    <td>
                      <div className="table-text-dark w-max-c db">
                        {item?.progressPercentage
                          ? item?.progressPercentage.toFixed(2)
                          : "0.00"}
                        %
                      </div>
                    </td>
                    <td>
                      <div className="table-text-dark w-max-c db">
                        {numeral(item?.reward).format("$0,0")} USD
                      </div>
                    </td>
                    <td>
                      <div className="table-text-dark w-max-c db">
                        {numeral(item?.profitMade).format("$0,0")} USD
                      </div>
                    </td>
                    <td>
                      <div className="table-text-dark w-max-c db">
                        {numeral(item?.lossMade).format("$0,0")} USD
                      </div>
                    </td>
                    <td>
                      <div className="table-text-dark w-max-c db">
                        {item?.planType}
                      </div>
                    </td>

                    <td scope="row">
                      <div className="table-text-dark w-max-c db">
                        {item?.exitTime ? formatDate(item?.exitTime) : "-"}
                      </div>
                    </td>
                    <td scope="row">
                      <div className="table-text-dark w-max-c db">
                        {formatDate(item?.startDate)}
                      </div>
                    </td>
                    <td>
                      <span className="table-text-dark w-max-c db">
                        {formatDate(item?.endDate)}
                      </span>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
          {/* <div className="d-flex justify-content-center">
            <Stack spacing={2}>
              <Pagination
                count={Math.ceil(noOfChallengs / limit)}
                page={page}
                onChange={handleChange}
              />
            </Stack>
          </div> */}
        </div>
      </div>
    </>
  );
};

export default ChallengesAdminByUserId;
